import { Channel } from "@libs/constants/channel"

export const channels: Array<Channel> = [
  {
    name: "bcp",
    context: {
      url: "/bcp",
      id: "bcp",
      logo: "/logo-bcp.svg",
      gtm: "OPT-5DPRVRH",
      hotjar: "3490160",
      background: "#012a8d",
      color: "white"
    }
  },
  {
    name: "yape",
    context: {
      url: "/yape",
      id: "yape",
      logo: "/logo-yape.png",
      background: "#5f2586",
      gtm: "OPT-MRKN26D",
      hotjar: "3490150"
    }
  },
  {
    name: "soatmibanco",
    context: {
      id: "soatmibanco",
      url: "/soatmibanco",
      gtm: "OPT-W7DB2KW",
      hotjar: "3490147"
    }
  }
]
